module.exports = __webpack_public_path__ + "img/Hu Tong.acbb7138.svg";